import { InMemoryCacheConfig } from "@apollo/client/cache";
import { typePolicies } from "./typePolicies";
import fragments from "../../generated/gateway-client-fragments.json";
import { uuidPossibleTypes } from "../../generated/uuid-possible-types";

export const inMemoryCacheConfig: InMemoryCacheConfig = {
  possibleTypes: {
    ...fragments.possibleTypes,
    ...uuidPossibleTypes,
  },
  typePolicies,
};
